import React, { useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { abrirVisor } from "@/lib/visor";

const nombreDe = (persona) => `Resumen de ingresos y gastos${persona ? ` - ${persona}` : ""}.pdf`;
const btn = "min-h-[56px] rounded-2xl bg-white border border-[#E5DFD5] text-[#1C2421] font-semibold text-base inline-flex items-center justify-center gap-2 hover:border-[#3A6B56] disabled:opacity-60";

// Resumen en PDF real (generado en el servidor): ver, imprimir, guardar y compartir.
export const ResumenAcciones = ({ rango, filtro, ids, ingresoIds, vacio, persona, porPersona }) => {
  const [busy, setBusy] = useState("");
  const NOMBRE = nombreDe(persona);
  const pdf = async () => {
    const r = await api.post("/gastos/resumen/pdf", { desde: rango.desde, hasta: rango.hasta, periodo: rango.label, filtro: filtro || null, ids, ingreso_ids: ingresoIds, persona: persona || null, por_persona: !!porPersona }, { responseType: "blob" });
    return new Blob([r.data], { type: "application/pdf" });
  };
  const run = (k, fn) => async () => {
    setBusy(k);
    try { await fn(await pdf()); } catch { toast.error("No se pudo generar el resumen. Inténtalo de nuevo."); } finally { setBusy(""); }
  };
  const ver = (b) => abrirVisor({ id: "resumen-gastos", title: `Resumen de ingresos y gastos${persona ? ` — ${persona}` : ""}`, original_filename: NOMBRE, blob: b });
  const guardar = (b) => {
    const url = URL.createObjectURL(b);
    const a = document.createElement("a");
    a.href = url; a.download = NOMBRE; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  };
  const imprimir = (b) => {
    const url = URL.createObjectURL(b);
    const fr = document.createElement("iframe");
    fr.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
    fr.src = url;
    fr.onload = () => { try { fr.contentWindow.focus(); fr.contentWindow.print(); } catch { ver(b); } setTimeout(() => { fr.remove(); URL.revokeObjectURL(url); }, 60000); };
    document.body.appendChild(fr);
  };
  const compartir = async (b) => {
    const file = new File([b], NOMBRE, { type: "application/pdf" });
    if (navigator.canShare?.({ files: [file] })) {
      try { await navigator.share({ files: [file], title: "Resumen de ingresos y gastos" }); } catch { /* cancelado */ }
    } else { guardar(b); toast("Tu dispositivo no permite compartir directamente: se ha descargado el PDF."); }
  };
  return (
    <div className="grid grid-cols-2 gap-2.5" data-testid="gastos-resumen-acciones">
      {[["ver", "Ver resumen", Icons.Eye, ver], ["imprimir", "Imprimir", Icons.Printer, imprimir], ["pdf", "Guardar PDF", Icons.Download, guardar], ["compartir", "Compartir", Icons.Share2, compartir]].map(([k, l, I, fn]) => (
        <button key={k} data-testid={`gastos-resumen-${k}`} disabled={!!busy || vacio} onClick={run(k, fn)} className={btn}>
          {busy === k ? <Icons.Loader2 size={20} className="animate-spin" /> : <I size={20} className="text-[#3A6B56]" />} {l}
        </button>
      ))}
    </div>
  );
};
